/* Shopify localization submits a country, keeping catalog, currency and purchase guards aligned. */
(function () {
  'use strict';
  if (window.__w99RegionControlsInitialized) return;
  window.__w99RegionControlsInitialized = true;
  var resetters = new WeakMap();
  function init(root) {
    root.querySelectorAll('[data-w99-region-controls]').forEach(function (controls) {
      if (controls.dataset.ready) return;
      var form = controls.closest('form');
      var region = controls.querySelector('[data-w99-region]');
      var currency = controls.querySelector('[data-w99-currency]');
      if (!form || !region || !currency) return;
      controls.dataset.ready = 'true';
      var options = Array.from(currency.options);
      var initialCountry = currency.value;
      var lastInternational = null;
      function apply(bucket, restore, requested) {
        var eligible = options.filter(function (option) { return option.dataset.region === bucket; });
        if (!eligible.length) {
          var current = options.find(function (option) { return option.value === currency.value; });
          if (current) region.value = current.dataset.region;
          return;
        }
        var wanted = requested || (restore ? lastInternational : currency.value);
        var selected = eligible.find(function (option) { return option.value === wanted; });
        if (!selected) selected = eligible.find(function (option) {
          return option.dataset.currency === 'USD' && option.value !== 'US';
        }) || eligible[0];
        currency.replaceChildren.apply(currency, eligible);
        currency.value = selected.value;
        region.value = bucket;
        if (bucket === 'INTL') lastInternational = selected.value;
      }
      function reset() {
        var initial = options.find(function (option) { return option.value === initialCountry; });
        if (initial) apply(initial.dataset.region, false, initialCountry);
      }
      region.addEventListener('change', function () { apply(region.value, region.value === 'INTL'); });
      currency.addEventListener('change', function () {
        if (region.value === 'INTL') lastInternational = currency.value;
      });
      form.addEventListener('submit', function () {
        apply(region.value, false);
        try { localStorage.setItem('wain99_geo_v1', 'chosen'); } catch (error) {}
        var returnTo = form.querySelector('input[name="return_to"]');
        if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
      });
      reset();
      controls.querySelector('[data-w99-region-field]').hidden = false;
      resetters.set(controls, reset);
    });
  }
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-w99-region-controls]').forEach(function (controls) {
      var reset = resetters.get(controls);
      if (reset) reset();
    });
  });
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
